import { render, staticRenderFns } from "./priceConfiguration1.vue?vue&type=template&id=4500d378&scoped=true&"
import script from "./priceConfiguration1.vue?vue&type=script&lang=js&"
export * from "./priceConfiguration1.vue?vue&type=script&lang=js&"
import style0 from "./priceConfiguration1.vue?vue&type=style&index=0&id=4500d378&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4500d378",
  null
  
)

export default component.exports